import { BrowserRouter, Routes, Route } from 'react-router';
import { ToastProvider } from '@podus/ui';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import VerifyOTP from './pages/VerifyOTP';
import DashboardLayout, { CASE_MANAGER_NAV, MEDIATOR_NAV } from './components/dashboard/DashboardLayout';
import AdminDashboard from './pages/Dashboard/Admin';
import AdminCaseManagement from './pages/Dashboard/Admin/CaseManagement';
import AdminInternalUsers from './pages/Dashboard/Admin/InternalUsers';
import InternalUserView from './pages/Dashboard/Admin/InternalUsers/InternalUserView';
import AdminFinancials from './pages/Dashboard/Admin/Financials';
import AdminSettings from './pages/Dashboard/Admin/Settings';
import CreateNewCase from './pages/Dashboard/Admin/CaseManagement/CreateNewCase';
import CaseManagerDashboard from './pages/Dashboard/CaseManager';
import CaseManagerCaseManagement from './pages/Dashboard/CaseManager/CaseManagement';
import CaseManagerSettings from './pages/Dashboard/CaseManager/Settings';
import MediatorDashboard from './pages/Dashboard/Mediator';
import MediatorMyCases from './pages/Dashboard/Mediator/MyCases';
import MediatorSettings from './pages/Dashboard/Mediator/Settings';

export function App() {
    return (
        <ToastProvider>
            <AuthProvider>
                <BrowserRouter>
                <Routes>
                    {/* Auth — public */}
                    <Route index element={<Login />} />
                    <Route path="login" element={<Login />} />
                    <Route path="verify-otp" element={<VerifyOTP />} />

                    {/* Admin Dashboard */}
                    <Route element={<ProtectedRoute role="Admin" />}>
                        <Route path="dashboard" element={<DashboardLayout />}>
                            <Route index element={<AdminDashboard />} />
                            <Route path="cases" element={<AdminCaseManagement />} />
                            <Route path="cases/new" element={<CreateNewCase />} />
                            <Route path="users" element={<AdminInternalUsers />} />
                            <Route path="users/:id" element={<InternalUserView />} />
                            <Route path="financials" element={<AdminFinancials />} />
                            <Route path="settings" element={<AdminSettings />} />
                        </Route>
                    </Route>

                    {/* Case Manager Dashboard */}
                    <Route element={<ProtectedRoute role="Case Manager" />}>
                        <Route
                            path="case-manager"
                            element={<DashboardLayout navItems={CASE_MANAGER_NAV} basePath="/case-manager" />}
                        >
                            <Route index element={<CaseManagerDashboard />} />
                            <Route path="cases" element={<CaseManagerCaseManagement />} />
                            <Route path="cases/new" element={<CreateNewCase />} />
                            <Route path="settings" element={<CaseManagerSettings />} />
                        </Route>
                    </Route>

                    {/* Mediator Dashboard */}
                    <Route element={<ProtectedRoute role="Mediator" />}>
                        <Route path="mediator" element={<DashboardLayout navItems={MEDIATOR_NAV} basePath="/mediator" />}>
                            <Route index element={<MediatorDashboard />} />
                            <Route path="cases" element={<MediatorMyCases />} />
                            <Route path="settings" element={<MediatorSettings />} />
                        </Route>
                    </Route>

                    <Route path="*" element={<Login />} />
                </Routes>
                </BrowserRouter>
            </AuthProvider>
        </ToastProvider>
    );
}
